module.exports = __webpack_public_path__ + "img/Proliferation-PRCA_10X_ACC.b1e19c73.png";